import { QueryFilter, QueryFilterEvent } from "../../interfaces/filters";

export function queryFilterReducer<T>(
  queryFilters: QueryFilter<T>[],
  event: QueryFilterEvent<T>,
) {
  switch (event.event) {
    case "update":
      if (
        queryFilters.some((qf) => qf.filterKey === event.queryFilter.filterKey)
      ) {
        return queryFilters.map((qf) => {
          if (qf.filterKey === event.queryFilter.filterKey) {
            Object.assign(qf, event.queryFilter);
          }
          return qf;
        });
      } else {
        return [...queryFilters, event.queryFilter];
      }
    case "delete":
      return queryFilters.filter((qf) => {
        return qf.filterKey !== event.queryFilter.filterKey;
      });
    case "replace":
      return event.queryFilter;
    case "reset":
      return [];
    default:
      return queryFilters;
  }
}
